import gsap from 'gsap';

function onBeforeEnter(el) {
    el.style.opacity = 0
  }
function onEnter(el, done) {
    gsap.to(el, {
      opacity: 1,
      onComplete: done,
      delay:0.6
    })
  }
function onLeave(el, done){
    gsap.to(el, {
      opacity: 0,
      onComplete: done
    })
  }

  export {
    onBeforeEnter, onEnter,onLeave
  }